interface AsyncStateProps {
  title?: string;
  message?: string;
  error?: unknown;
  onRetry?: () => void;
}

export function LoadingState({ title = "正在准备菜谱" }: AsyncStateProps) {
  return (
    <section className="state-card" aria-live="polite">
      <div className="loading-dot" aria-hidden="true" />
      <h1>{title}</h1>
      <p>正在从你的菜谱库读取最新内容。</p>
    </section>
  );
}

export function ErrorState({ title = "暂时无法读取", message, error, onRetry }: AsyncStateProps) {
  const detail = error instanceof Error ? error.message : "请稍后刷新重试。";
  return (
    <section className="state-card state-card--error" role="alert">
      <p className="eyebrow">连接提示</p>
      <h1>{title}</h1>
      <p>{message || detail}</p>
      {onRetry ? <button className="button button--quiet" type="button" onClick={onRetry}>重新尝试</button> : null}
    </section>
  );
}

export function EmptyState({ title = "这里还没有菜谱", message }: AsyncStateProps) {
  return (
    <section className="state-card">
      <p className="eyebrow">空菜谱架</p>
      <h1>{title}</h1>
      <p>{message || "发布第一道菜谱后，它会出现在这里。"}</p>
    </section>
  );
}
